/**
 * Created by pajicv on 9/26/18.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, Tab, Tabs, Toolbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import { ProjectCardEnhance, ProjectListEnhance } from '../common/ProjectCard.enhancer';
import { MANAGER_ROLE, CO_MANAGER_ROLE, WORKER_ROLE } from '../../utils/constants';
import { ViewList, Apps } from '@material-ui/icons';
import { isHavingOpenTasks } from '../../firebase/db/project';
import SearchBar from 'material-ui-search-bar'

const styles = theme => ({
  noProjectInfo: {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, 0%)'
  },
  noProjectText: {
    textAlign: 'center'
  },
  toolbar: {
    margin: '0 10%',
    display: 'flex',
    flexFlow: 'row wrap'
  },
  previewOpt: {
    position: 'absolute',
    right: 0
  },
  selectedIcon: {
    fontSize: 25
  },
  icon: {
    fontSize: 25,
    color: 'gray'
  },
  search: {
    position: 'absolute',
    top: '-15%',
    left: '15%',
    transform: 'translate(-50%, -50%)',
    width: '25%',
    height: 40,
    borderRadius: '25px'
  },
});

const isSetupCompleted = (project) => {
  const { title, targetGroups, useCases, members } = project;
  return title
    && targetGroups
    && useCases
    && members
    && (Object.keys(targetGroups).length > 0)
    && (Object.keys(useCases).length > 0)
    && (Object.keys(members).length > 0);
};

class ProjectListManager extends React.Component {
  constructor(props) {
    super(props);

    const { projects } = props;

    let initRole = MANAGER_ROLE;
    if (projects) {
      if (!projects.manager) {
        initRole = WORKER_ROLE;
        if (!projects.worker) {
          initRole = CO_MANAGER_ROLE;
        }
      }
      this.state = {
        role: initRole,
        managerSelectedView: '#list',
        workerSelectedView: '#grid',
        isHavingWork: false
      };
    } else {
      this.state = {
        role: initRole,
        managerSelectedView: '#list',
        workerSelectedView: '#grid',
        isHavingWork: false
      };
    }
  }

  componentDidMount() {
    const { props: { auth } } = this;
    isHavingOpenTasks(auth.email)
      .then(numberOfTasks => {
        const isHavingWork = numberOfTasks > 0;
        this.setState({ isHavingWork });
      });
  }

  handleChangeRole = (event, role) => {
    this.setState({ role });
    if (role !== 'manager') {
      this.changeView(role, "grid");
    }
  };

  renderTabs = () => {
    const { props: { projects }, state: { role, isHavingWork } } = this;

    return (
      <Tabs
        value={role}
        onChange={this.handleChangeRole}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        {projects.manager && <Tab value={MANAGER_ROLE} label="Management" />}
        {(projects.worker && isHavingWork) && <Tab value={WORKER_ROLE} label="Todos" />}
        {projects['co-manager'] && <Tab value={CO_MANAGER_ROLE} label="Co-manage" />}
      </Tabs>
    );
  };

  changeView = (role, selectedView) => {
    const { onLayoutChange } = this.props;
    window.location.hash = selectedView;
    if (role !== WORKER_ROLE) {
      this.setState({ managerSelectedView: '#' + selectedView });
    } else {
      this.setState({ workerSelectedView: '#' + selectedView });
    }
    onLayoutChange('#' + selectedView)
  };

  render() {
    const { classes, projects, onCreateUXCycle, onContinueSetup, onDeleteProject, onWorkerViewTasks, onWorkerViewTasksv2,auth } = this.props;
    const { role, managerSelectedView, workerSelectedView, isHavingWork } = this.state;
    return (
      (projects && (projects.manager || projects['co-manager'] || isHavingWork))
        ? (
          <React.Fragment>
            {this.renderTabs()}
            {role === 'manager' && <Toolbar className={classes.toolbar}>
              {managerSelectedView === '#list' && <SearchBar
                placeholder="Suche"
                className={classes.search}
                cancelOnEscape={true}
                onChange={(searchValue) => searchValue == '' && this.setState({ searchValue })}
                onRequestSearch={(searchValue) => this.setState({ searchValue })}
                onCancelSearch={() => this.setState({ searchValue: '' })}
              />
              }
              <Typography className={classes.previewOpt}>
                <ViewList className={
                  (managerSelectedView === '#list')
                    ? classes.selectedIcon
                    : classes.icon}
                  onClick={() => this.changeView(MANAGER_ROLE, 'list')} />
                <Apps className={
                  (managerSelectedView === '#grid')
                    ? classes.selectedIcon
                    : classes.icon}
                  onClick={() => this.changeView(MANAGER_ROLE, 'grid')} />
              </Typography>
            </Toolbar>}

            {(role !== WORKER_ROLE) && (managerSelectedView === '#grid') &&
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              >
                {
                  projects[role] && Object.keys(projects[role]).sort((proj1, proj2) => {
                    let date1 = projects[role][proj1]['createdOn']
                    let date2 = projects[role][proj2]['createdOn']
                    return date2 - date1;
                  }).map(projectId => (
                    <ProjectCardEnhance
                      key={`${projectId}_${role}`}
                      {...projects[role][projectId]}
                      projectId={projectId}
                      isSetupCompleted={isSetupCompleted(projects[role][projectId])}
                      onCreateUXCycleClick={onCreateUXCycle}
                      onContinueSetupClick={() => onContinueSetup(projectId)}
                      onDeleteProject={() => onDeleteProject(projectId)}
                      onWorkerViewTasks={() => onWorkerViewTasks(projectId)}
                      role={role}
                    />))
                }
              </div>
            }
            {(role !== WORKER_ROLE) && (managerSelectedView === '#list') &&
              <div id="wrapper">
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginLeft: '204px'
                }}>
                  <Typography variant="subheading">Projekte</Typography>
                  <Typography style={{ marginTop: 10 }}>AKTUELLSTES PROJEKT</Typography>
                </div>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  {projects['manager'] && Object.keys(projects['manager']).sort((proj1, proj2) => {
                    let date1 = projects['manager'][proj1]['createdOn']
                    let date2 = projects['manager'][proj2]['createdOn']
                    return date2 - date1;
                  }).map((projectId, index) => (
                    <ProjectListEnhance
                      key={projectId}
                      index={index}
                      {...projects['manager'][projectId]}
                      projectId={projectId}
                      isSetupCompleted={isSetupCompleted(projects['manager'][projectId])}
                      onCreateUXCycleClick={onCreateUXCycle}
                      onContinueSetupClick={() => onContinueSetup(projectId)}
                      onDeleteProject={() => onDeleteProject(projectId)}
                      onWorkerViewTasks={onWorkerViewTasks}
                      role={'manager'}
                      searchValue={this.state.searchValue}
                    />))}
                </div>
              </div>
            }
            {(role === WORKER_ROLE) && (workerSelectedView === '#grid') &&
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              >
                {
                  projects[role] && Object.keys(projects[role]).sort((proj1, proj2) => {
                    let date1 = projects[role][proj1]['createdOn']
                    let date2 = projects[role][proj2]['createdOn']
                    return date2 - date1;
                  }).map(projectId => (
                    <ProjectCardEnhance
                      key={`${projectId}_${role}`}
                      {...projects[role][projectId]}
                      projectId={projectId}
                      isSetupCompleted={isSetupCompleted(projects[role][projectId])}
                      onCreateUXCycleClick={onCreateUXCycle}
                      onContinueSetupClick={() => onContinueSetup(projectId)}
                      onDeleteProject={() => onDeleteProject(projectId)}
                      onWorkerViewTasks={() => onWorkerViewTasksv2(projectId, window.btoa(auth.email))}
                      role={role}
                    />))
                }
              </div>
            }
          </React.Fragment >
        ) : (
          <div className={classes.noProjectInfo}>
            <div className={classes.noProjectText}>
              <Typography variant="headline">Welcome to UX-SUITE</Typography>
              <Typography variant="subheading">
                Get started by creating a new project
                            </Typography>
            </div>
          </div>
        )
    );
  }
}

ProjectListManager.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(connect(state => ({
  auth: state.firebase.auth,
}))(ProjectListManager));



// WEBPACK FOOTER //
// ./src/components/ProjectOverview/ProjectListManager.js